import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const ProgressBarWrapper = styled.div`
  width: 100%;
  display: block;
  cursor: pointer;

  progress {
    margin-top: -12px;
  }

  progress, input {
      width: 100%;
      display: block;
      height: 20px;
  }

  progress[value] {
      -webkit-appearance: none;
         -moz-appearance: none;
              appearance: none;
      
      border: none;
      height: 5px;

      /* For IE10 */
      color: var(--color-tertiary-lighter);
  }

  progress[value]::-webkit-progress-value {
      background-color: var(--color-tertiary-lighter);
  }

  progress::-webkit-progress-bar {
    background-color: var(--color-tertiary-darker);
  }

  progress[value]::-moz-progress-bar {
      background-color: var(--color-tertiary-lighter);
  }

  input[type="range"] {
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      -moz-apperance: none !important;
      /* height: 4px; */
      background: none;
      outline: none !important;
      border: none;
      margin: 0;
      padding: 0;
  }

  input[type="range"]:focus {
      outline: none;
      border: none;
  }

  input[type="range"]::-moz-range-track {
      border: none;
      background: none;
      outline: none;
  }

  input[type="range"]::-ms-track {
      border: inherit;
      color: none; /* don't drawn vertical reference line */
      background: transparent;
  }

  input[type="range"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      background-color: var(--color-tertiary-lighter);
      height: 15px;
      width: 15px;
      border-radius: 50%;
  }

  input[type="range"]::-moz-range-thumb {
      -moz-appearance: none;
      background: var(--color-tertiary-lighter);
      height: 15px;
      width: 15px;
      border-radius: 50%;
      border: none;
  }

  input[type="range"]::-ms-thumb {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      border: 0;
      background: var(--color-tertiary-lighter);
  }

  input[type="range"]::-ms-fill-lower,
  input[type="range"]::-ms-fill-upper {
    background: transparent;
  }

  input[type="range"]::-ms-tooltip {
    display: none;
  }
`

const ProgressBar = (props) => (
  <ProgressBarWrapper>
    <input type="range" {...props} />
    <progress {...props} />
  </ProgressBarWrapper>
)

const Timer = ({ currentTime, duration }) => {
  const asSecString = (seconds) => {
    let secs = parseInt(seconds, 10)
    let mins = Math.floor(secs / 60)
    
    secs = secs - (mins * 60)
    
    if (mins < 10) {
      mins = "0" + mins
    }
    
    if (secs < 10) {
      secs = "0" + secs
    }
    
    return mins + ':' + secs
  }
  
  const [time, setTime] = useState(asSecString(0) + '/' + asSecString(0));

  useEffect(() => {
    const interval = setInterval(() => {
      if (!duration || !currentTime) {
        setTime("00:00/00:00")
      } else {
        setTime(asSecString(currentTime) + "/" + asSecString(duration))
      }
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, [duration, currentTime]);

  return (
    <span>{time}</span>
  );
};

const PlayBar = ({ currentTime, duration, isPlaying, pause, play, seek }) => {
  const [percent, setPercent] = useState(0)
  const [freezed, setFreezed] = useState(false)
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (!duration || !currentTime) {
        setPercent(0);
      } else {
        setPercent(currentTime / duration * 100 || 0)
      }
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, [currentTime, isPlaying]);
  
  const onChange = ({ target: { value } }) => {
    setPercent(value)
    seek((duration / 100) * percent)
  }

  const freeze = () => {
    setFreezed(true)
    pause()
  }

  const release = () => {
    setFreezed(false)
    play()
    seek((duration / 100) * percent)
  }

  return (
    <ProgressBar
      value={percent}
      max="100"
      step="1"
      min="0"
      onChange={onChange}
      onTouchStart={freeze}
      onTouchEnd={release}
      onMouseDown={freeze}
      onMouseUp={release}
    />
  )
};

export {
  PlayBar as default,
  Timer
}
